import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTenantAuth } from '../../contexts/TenantAuthContext';
import { TenantSettingsProvider } from '../../contexts/TenantSettingsContext';
import { authTokenService } from '../../services/auth.service';
import RouteGateFallback from '../ui/RouteGateFallback';

interface TenantProtectedRouteProps {
  children: React.ReactNode;
}

const TenantProtectedRoute: React.FC<TenantProtectedRouteProps> = ({ children }) => {
  const { tenant, loading, isAuthenticated } = useTenantAuth();
  const location = useLocation();

  // Show loading while checking auth state
  if (loading) {
    return <RouteGateFallback variant="auth" message="Loading tenant portal" />;
  }

  const claims = authTokenService.getClaims();
  if (claims?.role === 'TENANT' && claims.mustVerifyPhone) {
    return <Navigate to="/tenant/verify-phone" replace />;
  }

  // Redirect to tenant login if not authenticated
  if (!isAuthenticated || !tenant) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Render children with tenant settings (currency etc.) when authenticated
  return <TenantSettingsProvider>{children}</TenantSettingsProvider>;
};

export default TenantProtectedRoute;
